import {
  FLEETS_REALTIME_DATA_SUBSCRIBE,
  FLEETS_REALTIME_DATA_PUBLISH,
  FLEETS_REALTIME_DATA_FAILURE,
  FLEETS_REALTIME_DATA_UNSUBSCRIBE,
  FLEET_CREATE_REQUEST,
  FLEET_CREATE_FAILURE,
} from '../actionTypes';

const INITIAL_STATE = {};

export default function fleetReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FLEETS_REALTIME_DATA_SUBSCRIBE:
      return {
        ...state,
        inSyncFleets: true,
        syncFleetsError: null,
        firstPublish: false,
      };
    case FLEETS_REALTIME_DATA_PUBLISH:
      return {
        ...state,
        fleets: action.data,
        firstPublish: true,
      };
    case FLEETS_REALTIME_DATA_FAILURE:
      return {
        ...state,
        inSyncFleets: false,
        syncFleetsError: action.error,
        fleets: {},
      };
    case FLEETS_REALTIME_DATA_UNSUBSCRIBE:
      return {
        ...state,
        inSyncFleets: false,
        syncFleetsError: null,
        fleets: {},
      };
    case FLEET_CREATE_REQUEST:
      return {
        ...state,
        fleets: {
          ...state.fleets,
          [action.key]: {
            ...action.data,
            isLoading: true,
          },
        },
      };
    case FLEET_CREATE_FAILURE:
      return {
        ...state,
        fleets: {
          ...state.fleets,
          [action.key]: {
            isFailure: true,
            isLoading: false,
            error: action.error,
          },
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Fleet/fleet.reducer.js